import React from "react";
import SocialButton from "./social_login_button";
import GoodleIcon from "../../assets/img/google_icon.svg";

export default function GoogleButton({
  handleSocialLogin,
  handleSocialLoginFailure,
  label,
  loading,
  disabled,
}) {
  return (
    <SocialButton
      color="#7A7575"
      background="#FFFFFF"
      provider="google"
      loading={loading}
      appId="745704541063-hqva5p81cl0qftomi9gt30362sk95rfa.apps.googleusercontent.com"
      label={label}
      iconcomponent={() => <img src={GoodleIcon} alt="Google Icon" />}
      onLoginSuccess={handleSocialLogin}
      onLoginFailure={handleSocialLoginFailure}
      disabled={disabled}
    />
  );
}
